module.exports = __webpack_public_path__ + "img/BannerBrightFuture.d62f0b0c.png";